import { getGlobalWindowVariables } from 'utils/globalWindowVariables';
import { useSelectBuildVersion } from 'app/store/general/selectors';

export function useDisplayingOutdatedIndigoVersionWarning() {
    const globals = getGlobalWindowVariables();

    /*
     * Retrieved from server when the availability status became ready
     */
    const buildVersion = useSelectBuildVersion();
    /*
     * Current version running in the browser
     */
    const runningBuildVersion = globals.buildVersion;

    if (!runningBuildVersion) {
        return false;
    }

    if (!buildVersion) {
        return false;
    }

    if (buildVersion === runningBuildVersion) {
        return false;
    }

    return true;
}
